import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { IMAGES } from "@/data/content";

const TILES = [
  { img: IMAGES.interior, label: "Restaurant Interior", span: "md:col-span-2 md:row-span-2" },
  { img: IMAGES.cocktail, label: "Cocktails", span: "md:col-span-1 md:row-span-1" },
  { img: IMAGES.tandoori, label: "Tandoori", span: "md:col-span-1 md:row-span-1" },
  { img: IMAGES.curry, label: "Curries", span: "md:col-span-1 md:row-span-2" },
  { img: IMAGES.dessert, label: "Desserts", span: "md:col-span-1 md:row-span-1" },
  { img: IMAGES.family, label: "Family Dining", span: "md:col-span-1 md:row-span-1" },
  { img: IMAGES.bar, label: "The Bar", span: "md:col-span-2 md:row-span-1" },
  { img: IMAGES.biryani, label: "Biryani", span: "md:col-span-1 md:row-span-1" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-[#0D0D0D] py-24 md:py-32 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-[#C8A24A] uppercase text-xs tracking-[0.35em] mb-4">A Feast for the Eyes</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
              The <span className="italic text-gold-gradient">Gallery</span>
            </h2>
          </div>
          <p className="text-[#D6D6D6] font-light max-w-sm text-sm">
            Step inside the world of Ekaa — moody interiors, glowing cocktails, and
            dishes plated like art.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[190px] gap-4">
          {TILES.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
              data-testid={`gallery-tile-${i}`}
              className={`group relative overflow-hidden rounded-sm border border-[#C8A24A]/15 ${t.span}`}
            >
              <img src={t.img} alt={t.label} className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/90 via-transparent to-transparent opacity-80 group-hover:opacity-95 transition-opacity" />
              <div className="absolute inset-x-0 bottom-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform">
                <span className="text-[#C8A24A] text-[10px] tracking-[0.3em] uppercase">Ekaa</span>
                <p className="font-display text-xl md:text-2xl text-white">{t.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
